import i18n from 'i18next';
import zhContract from './locales/zh/contract.json';
import enContract from './locales/en/contract.json';

i18n.addResourceBundle('zh', 'contract', zhContract, true, true);
i18n.addResourceBundle('en', 'contract', enContract, true, true);
